import { Decimal } from 'decimal.js';
import currency, { default as Currency } from 'currency.js';
import { transformer as SuperJSON } from '@trashlab/api/transformer';

export const registerSuperJSONTransformers = () => {
  SuperJSON.registerCustom<Decimal, string>(
    {
      isApplicable: (v): v is Decimal => Decimal.isDecimal(v),
      serialize: (v) => v.toJSON(),
      deserialize: (v) => new Decimal(v),
    },
    'decimal.js',
  );

  SuperJSON.registerCustom<Currency, string>(
    {
      isApplicable: (v): v is Currency => v instanceof currency,
      serialize: (v) => v.toString(),
      deserialize: (v) => currency(v),
    },
    'currency.js',
  );
};
